"use strict";export const getTimestampInSeconds=()=>Math.floor(Date.now()/1e3);
